import { render, staticRenderFns } from "./ListSupports.vue?vue&type=template&id=38d74057&"
import script from "./ListSupports.vue?vue&type=script&lang=js&"
export * from "./ListSupports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports